// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CategorySelectCmp$PorterinFeature from "./CategorySelectCmp.mjs";
import * as CategorySelectorModuleScss from "../styles/CategorySelector.module.scss";

var styles = CategorySelectorModuleScss;

function CategorySelectorCmp(Props) {
  var onCategorySelect = Props.onCategorySelect;
  var category_cards_data = Props.category_cards_data;
  var arrow_icon = Props.arrow_icon;
  return React.createElement("div", {
              className: styles["category-selector-container"]
            }, React.createElement("div", {
                  className: styles["category-selector-cards"]
                }, category_cards_data.map(function (category_details, index) {
                      return React.createElement(CategorySelectCmp$PorterinFeature.make, {
                                  category_details: category_details,
                                  onCategorySelect: onCategorySelect,
                                  arrow_icon: arrow_icon,
                                  key: index.toString()
                                });
                    })));
}

var make = CategorySelectorCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
